module.exports = __webpack_public_path__ + "img/20190823165350QQ截图20190624162102.7fb9c3ce.png";